var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9549 2H3.04508C2.11588 2 1.65053 3.11328 2.30758 3.76438L8.56554 9.96567C8.76114 10.1595 8.87102 10.4224 8.87102 10.6965V19.9651C8.87102 20.7334 9.68697 21.2332 10.3805 20.8896L14.5524 18.8225C14.9058 18.6474 15.129 18.2895 15.129 17.898V10.6965C15.129 10.4224 15.2389 10.1595 15.4345 9.96567L21.6924 3.76438C22.3495 3.11328 21.8841 2 20.9549 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.8a93c5efb715f2796385892b06fa4c0f.svg";
export { ForwardRef as ReactComponent };